import api from 'app/shared/utils/api';
import promise from 'promise';

const StaticMapActions = {
    signUrl(url, params) {
        return dispatch => dispatch(api.users.signUrl(url, params))
            .then((response) => {
                if (response.success === false) {
                    // error
                    return promise.reject({
                        message: `ERROR: Request to sign url @ ${url}`,
                    });
                }
                // success
                return response.signedUrl;
            })
            .catch(error => promise.reject(error.message));
    },
};

export default StaticMapActions;
